(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  if (!customElements.get('cart-upsell')) {
    class CartUpsell extends HTMLElement {
      connectedCallback() {
        this.querySelector('[data-cart-upsell-add]')?.addEventListener('click', async (event) => {
          const button = event.currentTarget;
          button.setAttribute('aria-busy', 'true');

          try {
            const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                items: [{ id: Number(button.dataset.variantId), quantity: 1 }]
              })
            });

            if (!response.ok) {
              throw new Error('Unable to add product');
            }

            window.location.assign(`${window.Shopify.routes.root}cart`);
          } catch (error) {
            button.removeAttribute('aria-busy');
          }
        });
      }
    }

    customElements.define('cart-upsell', CartUpsell);
  }

  } catch(e) { console.error(e); }
})();
})();
